import { render, staticRenderFns } from "./storeHistoryListPage.vue?vue&type=template&id=62fd28d4&"
import script from "./storeHistoryListPage.vue?vue&type=script&lang=ts&"
export * from "./storeHistoryListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports